import { Injectable, Inject } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable({
  providedIn: 'root'
})

export class CreateService {

	private create = new Subject<any>();

	notifyObservable$ = this.create.asObservable();

  constructor() { }

  public notificarCreate(){
  		this.create.next();
  }
}
